export let ZIndex = /*#__PURE__*/function (ZIndex) {
  ZIndex["overthetop"] = "overthetop";
  ZIndex["tooltip"] = "tooltip";
  ZIndex["modal"] = "modal";
  ZIndex["navbar"] = "navbar";
  ZIndex["sidebar"] = "sidebar";
  ZIndex["popover"] = "popover";
  ZIndex["overlay"] = "overlay";
  ZIndex["inpage"] = "inpage";
  ZIndex["standard"] = "standard";
  ZIndex["below"] = "below";
  ZIndex["bottomless"] = "bottomless";
  return ZIndex;
}({});
export let SpacingName = /*#__PURE__*/function (SpacingName) {
  SpacingName[SpacingName["ZERO"] = 0] = "ZERO";
  SpacingName["AUTO"] = "auto";
  SpacingName["BIGGEST"] = "BIGGEST";
  SpacingName["BIGGER"] = "BIGGER";
  SpacingName["BIG"] = "BIG";
  SpacingName["MEDIUM"] = "MEDIUM";
  SpacingName["SMALL"] = "SMALL";
  SpacingName["SMALLER"] = "SMALLER";
  SpacingName["SMALLEST"] = "SMALLEST";
  SpacingName["NEGATIVE_BIGGEST"] = "-BIGGEST";
  SpacingName["NEGATIVE_BIGGER"] = "-BIGGER";
  SpacingName["NEGATIVE_BIG"] = "-BIG";
  SpacingName["NEGATIVE_MEDIUM"] = "-MEDIUM";
  SpacingName["NEGATIVE_SMALL"] = "-SMALL";
  SpacingName["NEGATIVE_SMALLER"] = "-SMALLER";
  SpacingName["NEGATIVE_SMALLEST"] = "-SMALLEST";
  return SpacingName;
}({});
//# sourceMappingURL=constants.js.map